import { IMAGES } from "@/lib/site-data";

const COLORS = ["Anthrazitgrau RAL 7016", "Weiß RAL 9016", "Verkehrsgrau RAL 7042", "Schwarz RAL 9005", "Holzdekor Golden Oak", "Holzdekor Nussbaum"];

export const CONFIGURATOR_PRODUCTS = IMAGES.products.map((p) => ({ name: p.name, img: p.img }));

export const PRODUCT_OPTIONS = {
  "Fenster": [
    { key: "material", label: "Material", choices: ["Kunststoff", "Kunststoff-Aluminium", "Aluminium"] },
    { key: "verglasung", label: "Verglasung", choices: ["2-fach", "3-fach (Wärmeschutz)", "3-fach + Schallschutz"] },
    { key: "oeffnung", label: "Öffnungsart", choices: ["Dreh-Kipp", "Nur Dreh", "Fest verglast", "Zweiflügelig"] },
    { key: "griff", label: "Griff", choices: ["Standard-Griff", "Abschließbarer Griff", "Edelstahl-Griff", "Design-Griff"] },
    { key: "dichtung", label: "Dichtung (Gummi)", choices: ["Standard grau", "Premium schwarz"] },
    { key: "sprossen", label: "Sprossen", choices: ["Ohne Sprossen", "Glasteilende Sprossen", "Aufsatzsprossen"] },
    { key: "sicherheit", label: "Sicherheit", choices: ["Standard", "Pilzkopf-Verriegelung", "RC2 einbruchhemmend"] },
  ],
  "Haustüren": [
    { key: "material", label: "Material", choices: ["Aluminium", "Kunststoff"] },
    { key: "seitenteil", label: "Seitenteil", choices: ["Ohne", "Links", "Rechts", "Beidseitig"] },
    { key: "griff", label: "Griff", choices: ["Griffstange Edelstahl", "Stoßgriff", "Klassischer Drücker"] },
    { key: "schloss", label: "Schloss", choices: ["Standard-Schloss", "Mehrfachverriegelung", "Fingerscanner"] },
    { key: "schwelle", label: "Bodenschwelle", choices: ["Standard-Schwelle", "Barrierefrei (0 cm)"] },
    { key: "oeffnungsrichtung", label: "Öffnungsrichtung", choices: ["DIN links", "DIN rechts"] },
    { key: "dichtung", label: "Dichtung (Gummi)", choices: ["Standard", "Premium-Dreifachdichtung"] },
    { key: "sicherheit", label: "Sicherheit", choices: ["Standard", "RC2 einbruchhemmend"] },
  ],
  "Rollläden": [
    { key: "antrieb", label: "Antrieb", choices: ["Elektrisch (Motor)", "Gurtzug", "Kurbel"] },
    { key: "einbau", label: "Einbauart", choices: ["Vorsatz (sichtbarer Kasten)", "Aufsatz (Neubau)", "Unterputz"] },
    { key: "smart", label: "Smart Home", choices: ["Ohne", "Mit Funksteuerung", "Mit App-Steuerung"] },
    { key: "behang", label: "Behang", choices: ["PVC-Behang", "Aluminium-Behang"] },
    { key: "fuehrung", label: "Führungsschienen", choices: ["Standard-Führung", "Gedämmte Führung"] },
  ],
  "Sonnenschutz": [
    { key: "art", label: "Art", choices: ["Textilscreen (Zip)", "Gelenkarm-Markise", "Raffstore"] },
    { key: "antrieb", label: "Antrieb", choices: ["Motor", "Manuell"] },
    { key: "kassette", label: "Kassette", choices: ["Offen", "Kassette (geschlossen)"] },
    { key: "sensor", label: "Sensorik", choices: ["Ohne Sensor", "Windsensor", "Wind + Sonne"] },
  ],
  "Insektenschutz": [
    { key: "art", label: "Ausführung", choices: ["Spannrahmen (Fenster)", "Drehtür", "Schiebeanlage", "Plissee-Tür"] },
    { key: "gewebe", label: "Gewebe", choices: ["Standard-Gewebe", "Pollenschutz", "UV-beständig"] },
  ],
  "Wintergarten": [
    { key: "dach", label: "Dachform", choices: ["Pultdach", "Satteldach"] },
    { key: "verglasung", label: "Verglasung", choices: ["2-fach", "3-fach (ganzjährig nutzbar)"] },
    { key: "beschattung", label: "Beschattung", choices: ["Ohne", "Dachmarkise", "Unterdachmarkise"] },
    { key: "boden", label: "Boden", choices: ["Ohne (Bestand)", "Gedämmter Boden"] },
    { key: "lueftung", label: "Belüftung", choices: ["Ohne", "Fensterlüfter", "Dachlüfter motorisch"] },
  ],
  "Vordächer": [
    { key: "tragwerk", label: "Tragwerk", choices: ["Anthrazit-Stahl", "Edelstahl"] },
    { key: "glas", label: "Glas", choices: ["VSG klar", "VSG satiniert (milchig)"] },
    { key: "beleuchtung", label: "Beleuchtung", choices: ["Ohne", "LED-Spots integriert"] },
    { key: "entwaesserung", label: "Entwässerung", choices: ["Freiablauf", "Regenrinne mit Rohr"] },
  ],
  "Schiebetüren": [
    { key: "typ", label: "System", choices: ["Hebe-Schiebe", "Parallel-Schiebe-Kipp"] },
    { key: "fluegel", label: "Flügel", choices: ["2-flügelig", "3-flügelig"] },
    { key: "verglasung", label: "Verglasung", choices: ["2-fach", "3-fach"] },
    { key: "griff", label: "Griff", choices: ["Standard-Griff", "Griffmulde flächenbündig", "Abschließbar"] },
    { key: "schwelle", label: "Schwelle", choices: ["Standard-Schwelle", "0-cm barrierefrei"] },
  ],
  "Garagentore": [
    { key: "torart", label: "Torart", choices: ["Sektionaltor", "Rolltor", "Schwingtor"] },
    { key: "antrieb", label: "Antrieb", choices: ["Mit Motor & Handsender", "Ohne Motor"] },
    { key: "daemmung", label: "Dämmung", choices: ["Gedämmt", "Ungedämmt"] },
    { key: "griff", label: "Griff", choices: ["Drehgriff", "Drucktaster", "Elektr. Schloss"] },
    { key: "schluepftuer", label: "Schlupftür", choices: ["Ohne", "Schlupftür seitlich", "Schlupftür im Tor"] },
    { key: "sichtfenster", label: "Sichtfenster", choices: ["Ohne", "Sichtfenster-Reihe"] },
  ],
  "Zäune": [
    { key: "system", label: "Zaunsystem", choices: ["Lamellenzaun (Sichtschutz)", "Stabzaun", "Kombination mit Pfosten"] },
    { key: "tor", label: "Tor", choices: ["Ohne Tor", "Drehtor", "Schiebetor (elektrisch)"] },
    { key: "pfosten", label: "Pfosten", choices: ["Sichtbare Pfosten", "Verdeckte Pfosten"] },
    { key: "fuellung", label: "Füllung", choices: ["Volle Lamellen", "Lamellen mit Glas-Element"] },
  ],
  "Pergolen": [
    { key: "dach", label: "Dach", choices: ["Drehbares Lamellendach", "Festverglasung"] },
    { key: "seiten", label: "Seiten", choices: ["Offen", "Senkrecht-Screens", "Glasschiebewände"] },
    { key: "licht", label: "Beleuchtung", choices: ["Ohne", "LED integriert"] },
    { key: "heizstrahler", label: "Heizstrahler", choices: ["Ohne", "1 Heizstrahler", "2 Heizstrahler"] },
  ],
};

export { COLORS };

// Echte Detailfotos für Hardware-Optionen (Griffe, Schlösser) – Schlüssel: "optionKey:Wahl"
export const EXTRAS = [
  "Montage durch Ringel-Team",
  "Entsorgung der Altelemente",
  "Elektrischer Anschluss",
  "Vermessung vor Ort",
];
